<template lang="html">
	<v-sheet class="w-100 h-100 d-flex justify-center align-center" color="transparent">
		<v-chip class="document-count-chip" :color="value ? 'primary' : ''" small>
			<v-avatar left small>
        <v-icon small>{{ value ? 'mdi-file-document-check-outline' : 'mdi-file-document-remove-outline' }}</v-icon>
      </v-avatar>
			<span class="font-weight-bold pl-1">{{ value }}</span>
		</v-chip>
	</v-sheet>
</template>
<script>
  export default {
    name: 'DocumentsCountRenderer',
    computed: {
      value() {
        return this.params.value;
      },
    },
  };
</script>
<style lang="scss">
.document-count-chip {
	.v-chip__content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
	}
}
</style>
